import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Modal from '../Modal';
import styles from './Spinner.module.scss';

export const THEME_NORMAL = 'normal';
export const THEME_TRANSPARENT = 'transparent';
export const THEME_BLOCK_PURPLE = 'block-purple';

const Spinner = ({ isModalWrapping, theme }) => {
  if (isModalWrapping) {
    return (
      <Modal onClose={() => {}}>
        <div className={styles.loader} />
      </Modal>
    );
  }
  return (
    <>
      <div
        className={classNames({
          [styles.background]: theme === THEME_NORMAL,
          [styles['background-transparent']]: theme === THEME_TRANSPARENT,
        })}
      />
      {theme === THEME_NORMAL && <div className={styles.loader} />}
      {theme === THEME_BLOCK_PURPLE && <div className={styles['loader-purple']} />}
    </>
  );
};
Spinner.propTypes = {
  isModalWrapping: PropTypes.bool,
  theme: PropTypes.oneOf([THEME_NORMAL, THEME_TRANSPARENT, THEME_BLOCK_PURPLE]),
};

Spinner.defaultProps = {
  isModalWrapping: true,
  theme: THEME_NORMAL,
};

export default Spinner;
